<template>
    <form-row title="Insurance">
        <input-money
            :value="mortgage.insurance"
            name="insurance"
            :read_only="read_only"
        />

        <input-radio-boolean
            class="mt-4 sm:-mt-1 sm:ml-10 flex-1"
            label="Is your bank escrowing and paying your insurance?"
            name="is_bank_escrowing_insurance"
            :value="mortgage.is_bank_escrowing_insurance"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
